import React from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  Typography,
  TableBody,
} from '@common-ui/ui';
import workItemEnum from '../../enums/workItemEnum';
import temperatureEnum from '../../enums/temperatureEnum';

export default function MarkerInfo({ markerData, temperature = temperatureEnum.FAHRENHEIT }) {
  const Cell = ({ text, color, variant }) => (
    <TableCell align="left">
      <Typography variant={variant} sx={{ color: color }}>
        {text}
      </Typography>
    </TableCell>
  );

  const MarkerHeader = () => (
    <TableRow>
      <Cell variant="h5" text={workItemEnum.MARKER_NAME} />
      <Cell variant="h5" text={workItemEnum.MAX_TEMPERATURE} />
      <Cell variant="h5" text={workItemEnum.DELTA_T} />
      <Cell variant="h5" text={workItemEnum.REFERENCE} />
    </TableRow>
  );

  const changeDeltaStyling = (delta) => {
    if (Number(delta) > 0) return '#0A59AD';
    if (Number(delta) < 0) return '#CC4747';
  };

  const getDeltaTempValue = (marker, temperatureKey) => {
    let response = '---';
    if (marker?.delta) {
      if (typeof marker?.delta === 'object' && temperatureKey in marker?.delta) {
        response = `${marker?.delta[temperatureKey]} ${temperature}`;
      } else {
        response = marker?.delta;
      }
    }

    return response;
  };

  const MarkerData = () =>
    markerData &&
    Object.values(markerData)?.map((marker, index) => (
      <TableRow key={index}>
        <Cell text={marker?.markername} />
        <Cell text={`${marker?.maxtemperature[temperature]} ${temperature}`} />
        <Cell
          text={getDeltaTempValue(marker, temperature)}
          color={marker?.delta ? changeDeltaStyling(marker?.delta[temperature]) : null}
        />
        <Cell
          text={marker?.reference ? `${marker?.maxtemperature[temperature]} ${temperature}` : '---'}
        />
      </TableRow>
    ));

  const ShowMarkerData = () => (markerData ? <MarkerData /> : null);

  return (
    <div>
      <Typography variant="h5" className="workItem__header">
        {workItemEnum.MARKER_INFO}
      </Typography>
      <TableContainer sx={table}>
        <Table size="small">
          <TableHead>
            <MarkerHeader />
          </TableHead>
          <TableBody>
            <ShowMarkerData />
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

const table = { border: '1px solid rgba(224, 224, 224, 1)', width: '600px', borderBottom: 0 };
